import React from 'react';
import { ErrorMessage } from 'formik';
import LabelR from '../../Simple/LabelR';
import GroupButton from '../Buttons/GroupButton';

const GroupButtonFormik = (props) => {
  const {
    field: { name },
    form: { setFieldValue, setFieldTouched, errors, touched },
    label,
    required,
    requiredFields = [name],
    disabled,
    onChange = () => { },
    onItemCheck = () => { },
    onItemUncheck = () => { },

  } = props;

  const handleAffectedFields = (affectedFields) => {
    if (affectedFields) {
      Object.keys(affectedFields).forEach(key => setFieldValue(key, affectedFields[key]));
    }
  };

  return (
    <div className="form-group">
      {
        label && (
          required
            ? <LabelR requiredFields={requiredFields} isEditable={!disabled} htmlFor={name}>{label}</LabelR>
            : <label htmlFor={name}>{label}</label>
        )
      }
      <GroupButton
        onCheckItem={
          (item) => {
            const fieldsAffected = onItemCheck(item);
            handleAffectedFields(fieldsAffected);
          }
        }
        onUncheckItem={
          (item, checkItems) => {
            const val = Object.keys(checkItems).map((key) => { return (checkItems[key]) ? key : false; }).filter(v => v);
            const fieldsAffected = onItemUncheck(item, val);
            handleAffectedFields(fieldsAffected);
          }
        }
        onItemsChanged={
          (itemsSel) => {
            const val = Object.keys(itemsSel).map((key) => { return (itemsSel[key]) ? key : false; }).filter(v => v);
            setFieldTouched(name, val);
            setFieldValue(name, val);
            onChange(val, handleAffectedFields);
          }
        }
        {...props}
      />
      {touched[name] && errors[name] && <ErrorMessage name={name} component="div" className="invalid-feedback" />}
    </div>
  );
};

export default GroupButtonFormik;
